import { handleActions } from "redux-actions";
import {
  documentListError,
  downloadDocument,
  getDocumentsList,
  setDocumentsList
} from "../actions/orderDocuments";

const initState = {
  documents: null,
  isLoading: false,
  errorMessage: null,
  errors: null
};

const documentsListReducer = handleActions(
  {
    [getDocumentsList]: state => {
      return {
        ...state,
        isLoading: true
      };
    },
    [setDocumentsList]: (state, action) => {
      return {
        ...state,
        documents: action.payload,
        isLoading: false
      };
    },
    [downloadDocument]: state => state,
    [documentListError]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors };
    }
  },
  initState
);

export default documentsListReducer;
